import React, { useState } from 'react';
import { TabSider } from '../../Chat/ChatDashboard/components/sider';
import { OverviewTab, TopicsTab, QuestionAnalysisTab, FeedbackTab } from '../../Chat/ChatDashboard/components/tabs';
import {
  ChatDashboardTab,
  ChatDashboardTabConfig,
  DashboardDateRange,
} from '../../Chat/ChatDashboard/types';
 
const TABS: ChatDashboardTabConfig[] = [
  { key: 'overview',           label: 'Overview' },
  { key: 'topics',             label: 'Topics' },
  { key: 'question-analysis',  label: 'Question Analysis' },
  { key: 'feedback',           label: 'Feedback' },
];
 
const getInitialDateRange = (): DashboardDateRange => {
  const toISO = (date: Date) => date.toISOString().split('T')[0];
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 7);
  return { startDate: toISO(start), endDate: toISO(end) };
};
 
const ChatAnalyticsContent: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ChatDashboardTab>('overview');
  const [dateRange, setDateRange] = useState<DashboardDateRange>(getInitialDateRange);
 
  const tabProps = {
    dateRange,
    onDateRangeChange: setDateRange,
  };
 
  const renderActiveTab = () => {
    switch (activeTab) {
      case 'topics':
        return <TopicsTab {...tabProps} />;
      case 'question-analysis':
        return <QuestionAnalysisTab {...tabProps} />;
      case 'feedback':
        return <FeedbackTab {...tabProps} />;
      case 'overview':
      default:
        return <OverviewTab {...tabProps} />;
    }
  };
 
  return (
    <div className="flex w-full h-full bg-gray-50 overflow-hidden" style={{ minHeight: 'calc(100vh - 120px)' }}>
      <TabSider tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} />
      <div className="flex-1 flex flex-col h-full p-6">
        <div className="flex-1 bg-white rounded-2xl shadow-sm p-6 sm:p-8 overflow-hidden">
          {renderActiveTab()}
        </div>
      </div>
    </div>
  );
};
 
export default ChatAnalyticsContent;